import axiosClient from '@/api/axiosClient';

export interface UploadFilesResponse<TItem = unknown> {
  items?: TItem[];
  count?: number;
  page?: number;
  pageSize?: number;
  totalCount?: number;
}

export async function getUploadFilesApi<TItem = unknown> (
  query?: string,
  page = 1,
  pageSize = 20,
  signal?: AbortSignal
): Promise<UploadFilesResponse<TItem>> {
  const response = await axiosClient.get<UploadFilesResponse<TItem>>('v2/upload/files', {
    params: {
      query: query?.trim() || undefined,
      page,
      pageSize
    },
    signal
  });

  return response.data;
}
